import { logger } from 'utils';
import types from '../types';

import {
    INIT,
    SET_CURRENT_PAGE,
    SET_ITEMS,
    SET_SEARCH_VALUE,
    SET_FILTERS,
    SET_IS_LOADING,
    SET_IS_LOADING_MORE,
    SET_PAGINATION
} from './actions';

/**
 * @typedef Action
 * @type {Object}
 * @property {any} payload
 * @property {string} type
 */

/**
 * @param {types.State} state
 * @param {Action} action
 * @returns {State}
 */
const reducer = (state, action) => {
    const { type } = action;

    logger(action);

    switch (type) {
        case INIT: {
            const { payload } = action;

            return payload;
        }

        case SET_ITEMS: {
            const { payload } = action;

            return {
                ...state,
                items:
                    payload && payload.isMerging
                        ? [...state.items, ...payload.items]
                        : payload.items || []
            };
        }

        case SET_SEARCH_VALUE: {
            const { payload } = action;

            return {
                ...state,
                searchValue: payload
            };
        }

        case SET_FILTERS: {
            const { payload } = action;

            return {
                ...state,
                filters: payload
            };
        }

        case SET_CURRENT_PAGE: {
            const { payload } = action;

            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    currentPage: payload
                }
            };
        }

        case SET_PAGINATION: {
            const { payload } = action;

            return {
                ...state,
                pagination: payload
            };
        }

        case SET_IS_LOADING: {
            const { payload } = action;

            return {
                ...state,
                isLoading: payload
            };
        }

        case SET_IS_LOADING_MORE: {
            const { payload } = action;

            return {
                ...state,
                isLoadingMore: payload
            };
        }

        default:
            return state;
    }
};

export default reducer;
